import { render, staticRenderFns } from "./ModelProvider.vue?vue&type=template&id=e5aaf98c&"
import script from "./ModelProvider.vue?vue&type=script&lang=js&"
export * from "./ModelProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5aaf98c')) {
      api.createRecord('e5aaf98c', component.options)
    } else {
      api.reload('e5aaf98c', component.options)
    }
    module.hot.accept("./ModelProvider.vue?vue&type=template&id=e5aaf98c&", function () {
      api.rerender('e5aaf98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModelProvider.vue"
export default component.exports